var _ellipse, _circle, _circle2, _ellipse2, _circle3, _rect, _rect2, _ellipse3, _ellipse4, _circle4, _circle5, _path, _ellipse5, _ellipse6, _path2, _circle6, _line, _circle7, _path3, _line2, _circle8, _circle9, _path4, _path5, _path6, _circle10, _path7, _circle11, _path8, _line3, _circle12, _path9, _path10, _circle13, _line4, _circle14, _circle15, _circle16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 752,
    height: 651,
    viewBox: "0 0 752 651",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "blooming") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 359,
    cy: 558,
    rx: 359,
    ry: 93,
    fill: "#f2f2f2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 495.60295,
    cy: 173.28526,
    r: 61.18574,
    fill: "#9a4332"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.60295,
    cy: 317.28526,
    r: 61.18574,
    fill: "#9a4332"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 392,
    cy: 539,
    rx: 359,
    ry: 93,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.80455,
    cy: 429.5,
    r: 79,
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 88.80455,
    y: 491.5,
    width: 24,
    height: 43,
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 136.80455,
    y: 491.5,
    width: 24,
    height: 43,
    fill: "#2f2e41"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.80455,
    cy: 535,
    rx: 20,
    ry: 7.5,
    fill: "#2f2e41"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.80455,
    cy: 534,
    rx: 20,
    ry: 7.5,
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.80455,
    cy: 409.5,
    r: 27,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.80455,
    cy: 409.5,
    r: 9,
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M272.67189,480.53228c-6.37889-28.56758,14.01185-57.43392,45.544-64.47477s62.2651,10.41,68.644,38.9776-14.51861,39.10379-46.05075,46.14464S279.05077,509.09986,272.67189,480.53228Z",
    transform: "translate(-224.5 -124.5)",
    fill: "#9a4332"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 418.51967,
    cy: 526.84365,
    rx: 39.5,
    ry: 12.40027,
    transform: "translate(-398.04153 82.67744) rotate(-23.17116)",
    fill: "#2f2e41"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 270.51967,
    cy: 579.84365,
    rx: 39.5,
    ry: 12.40027,
    transform: "translate(-430.83457 28.71783) rotate(-23.17116)",
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M395.30455,577c0,7.732-19.90861,23-42,23s-43-14.268-43-22,20.90861-6,43-6S395.30455,569.268,395.30455,577Z",
    transform: "translate(-224.5 -124.5)",
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.60295,
    cy: 432.28526,
    r: 61.18574,
    fill: "#9a4332"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 274.54857,
    y1: 542.93724,
    x2: 274.54857,
    y2: 431.94868,
    fill: "#3f3d56",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.54857,
    cy: 431.94868,
    r: 15.69535,
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M499.04857,624.85322s-2.2422-48.2248-48.20716-42.61932",
    transform: "translate(-224.5 -124.5)",
    fill: "#3f3d56"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 495.64133,
    y1: 543.71584,
    x2: 495.64133,
    y2: 173.51003,
    fill: "#3f3d56",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 495.64133,
    cy: 173.33464,
    r: 15.69535,
    fill: "#3f3d56"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.43418,
    cy: 441.18044,
    r: 15.69535,
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M720.14133,378.00726s-2.24219-48.2248-48.20715-42.61932",
    transform: "translate(-224.5 -124.5)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M720.14133,514.71915s-2.24219-48.22481-48.20715-42.61933",
    transform: "translate(-224.5 -124.5)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M720.14133,663.9015s10.08987-93.73668-48.20715-98.22106",
    transform: "translate(-224.5 -124.5)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 543.85536,
    cy: 441.18044,
    r: 15.69535,
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M720.14821,663.9015s-10.08987-93.73668,48.20715-98.22106",
    transform: "translate(-224.5 -124.5)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.81139,
    cy: 293.95226,
    r: 15.69535,
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M721.10423,511.67332s-10.08987-88.73668,48.20716-93.22106",
    transform: "translate(-224.5 -124.5)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 391.65878,
    y1: 543.19385,
    x2: 391.65878,
    y2: 317.21673,
    fill: "#3f3d56",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.65878,
    cy: 317.21673,
    r: 15.69535,
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M616.15878,505.63689s-2.24219-48.22481-48.20715-42.61933",
    transform: "translate(-224.5 -124.5)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M616.15878,663.37952s10.08987-92.73668-48.20715-97.22107",
    transform: "translate(-224.5 -124.5)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.45163,
    cy: 441.65845,
    r: 15.69535,
    fill: "#3f3d56"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 218.50674,
    y1: 542.97644,
    x2: 542.50674,
    y2: 542.97644,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 661,
    cy: 351,
    r: 32,
    fill: "#f2f2f2"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 157,
    cy: 151,
    r: 32,
    fill: "#f2f2f2"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 32,
    r: 32,
    fill: "#f2f2f2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg1);
export default __webpack_public_path__ + "static/media/svg-1.fd63a8aba5759779eab01be57802cbae.svg";
export { ForwardRef as ReactComponent };